import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { PeremrillojiParametri, PeremriNumri, PeremriRasa } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriPyetesFormulaService } from './peremri-pyetes-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriPyetesService {

  constructor(
    private fb: UntypedFormBuilder,
    private peremriPyetesFormulaService: PeremriPyetesFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriPyetes') as UntypedFormArray;
    this.generateLidhoreForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('vetaId')?.value == item.vetaId &&
          c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == ''
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.numriId, item.rasaId, item.pershkrimi);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateLidhoreForms(form.get('peremriBaza.peremriPyetes') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriPyetes') as UntypedFormArray;
    this.peremriPyetesFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateLidhoreForms(formArray: UntypedFormArray, manual: boolean) {

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const pn of PeremriConstants.PeremriNumri) {
      for (const pr of PeremriConstants.PeremriRasat) {
        const peremriForm = this.fb.group({
          numriId: pn.id,
          rasaId: pr.id,
          pershkrimi: '',
        });

        formArray.push(peremriForm);
      }
    }

    for (const pr of PeremriConstants.PeremriRasat) {
      const peremriForm = this.fb.group({
        numriId: null,
        rasaId: pr.id,
        pershkrimi: '',
      });

      formArray.push(peremriForm);
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, numri: PeremriNumri | null, rasa: PeremriRasa | null, pershkrimi?: string) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriPyetes');
    const peremriForm = this.fb.group({
      numriId: numri,
      rasaId: rasa,
      pershkrimi: pershkrimi
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriPyetes') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        numriId: p.numriId,
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi
      })
    })
    return creationDTO;
  }
}
